import { getClerkTokenGetter } from "./clerk-token-provider"

export async function getAuthToken(): Promise<string> {
  const getToken = getClerkTokenGetter()
  // Use default session token - we fetch metadata from Clerk API in the backend
  const token = await getToken()
  
  if (!token) {
    throw new Error("Failed to get authentication token")
  }
  
  return token
}
